module.exports = "/static/assets/bd0654a64acea4ed0382b083f524b353.png";